export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });
}

/**
 * Вырезает область, выбранную пользователем в кроппере, и приводит её
 * к квадрату outputSize×outputSize — тем самым итоговый файл уже квадратный,
 * а не обрезается «на глаз» через CSS object-fit при каждом показе.
 */
export async function cropImageToSquare(
  imageUrl: string,
  crop: PixelCrop,
  outputSize = 640,
): Promise<Blob> {
  const image = await loadImage(imageUrl);
  const canvas = document.createElement('canvas');
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas 2D context unavailable');
  }

  // Белая подложка: PNG с прозрачностью иначе станет чёрным квадратом,
  // потому что JPEG альфа-канала не хранит.
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, outputSize, outputSize);

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    outputSize,
    outputSize,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Canvas is empty'))),
      'image/jpeg',
      0.9,
    );
  });
}
